import { Component, EventEmitter, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

// The chart type a single data series can be drawn as (area = a filled line).
export type SeriesChartType = 'line' | 'bar' | 'scatter' | 'area';

// Types offered per series, in menu order.
export const SERIES_CHART_TYPES: { value: SeriesChartType; label: string }[] = [
  { value: 'line', label: 'Line' },
  { value: 'bar', label: 'Bar' },
  { value: 'scatter', label: 'Scatter' },
  { value: 'area', label: 'Area' }
];

// One series row in the dialog. An empty type means "follow the chart type".
export interface SeriesTypeRow {
  name: string;
  color: string;
  type: SeriesChartType | '';
}

// Values passed in via `initialState` when the modal is opened.
export interface SeriesTypeModalParams {
  rows: SeriesTypeRow[];
  defaultTypeLabel: string;
}

// Result emitted back to the caller: only the overridden series.
export interface SeriesTypeResult {
  [seriesName: string]: SeriesChartType;
}

// Dialog for choosing the chart type of each data series. Opened by the eChart
// component from the "Chart type per series" icon in the control row.
@Component({
  standalone: false,
  selector: 'series-type-modal',
  templateUrl: './series-type-modal.component.html',
  styleUrls: ['./series-type-modal.component.scss']
})
export class SeriesTypeModalComponent implements SeriesTypeModalParams {
  // Fired when the user applies; the caller subscribes to this.
  @Output() onApply = new EventEmitter<SeriesTypeResult>();

  rows: SeriesTypeRow[] = [];
  defaultTypeLabel = 'Line';
  types = SERIES_CHART_TYPES;

  // Only allow dragging while the pointer is over the header (matches the other
  // modals in this app).
  modalDragOn = false;

  constructor(public bsModalRef: BsModalRef) {}

  setDragOn(on: boolean): void {
    this.modalDragOn = on;
  }

  apply(): void {
    const result: SeriesTypeResult = {};
    this.rows.forEach(r => {
      if (r.type !== '') {
        result[r.name] = r.type;
      }
    });
    this.onApply.emit(result);
    this.bsModalRef.hide();
  }

  // Set every series back to the chart type (does not close).
  resetAll(): void {
    this.rows.forEach(r => r.type = '');
  }

  cancel(): void {
    this.bsModalRef.hide();
  }
}
